/**
 * TARAYICI DESTEĞİ — F-PPL yok, arayüz kararı
 *
 * ================================================================
 * SÜRÜM NUMARASI OKUNMUYOR, YETENEK ÖLÇÜLÜYOR
 * ================================================================
 * `userAgent` içinden sürüm ayıklamak bu tarayıcı savaşını
 * kaybetmenin bilinen yolu: her tarayıcı başkasının adını taşıyor,
 * her yeni sürüm dizgiyi değiştiriyor ve listeler eskiyor. En kötüsü,
 * yanlış eşleşen bir kural ÇALIŞAN bir tarayıcıyı engelliyor.
 *
 * Onun yerine arayüzün gerçekten ihtiyaç duyduğu şeyler tek tek
 * soruluyor. Biri yoksa ekran zaten yanlış çizilecek demektir.
 *
 * ================================================================
 * LİSTE DAR TUTULUYOR
 * ================================================================
 * Yalnızca YOKLUĞU ekranı bozacak yetenekler burada. "Olsa iyi olur"
 * diye eklenen her madde, çalışabilecek bir tarayıcıyı kapı önünde
 * bırakma riski taşıyor — ve engellenen kullanıcı ne yapacağını
 * bilmiyor.
 */

export interface YetenekSonucu {
  destekli: boolean;
  /** Eksik olanların adları — konsola yazmak ve teşhis için. */
  eksikler: string[];
}

export function tarayiciYetenekleri(pencere: {
  CSS?: { supports?: (deger: string) => boolean };
  structuredClone?: unknown;
  Intl?: unknown;
}): YetenekSonucu {
  const eksikler: string[] = [];

  /*
    CSS DEĞİŞKENLERİ — bütün tasarım belirteçleri onların üstünde.
    Yoksa ekran renksiz ve ölçüsüz çizilir; "biraz bozuk" değil,
    okunamaz olur.
  */
  const destekler = pencere.CSS?.supports;
  if (typeof destekler !== "function" || !destekler("color: var(--x)")) {
    eksikler.push("CSS değişkenleri");
  }

  /*
    `structuredClone` — 2022 sonrası her tarayıcıda var ve iyi bir
    sınır işareti: varsa tarayıcı yeterince yeni demektir. Kendi
    kodumuz doğrudan kullanmıyor; burada bir YAŞ ÖLÇÜSÜ olarak
    duruyor ve bunu yazmak gerekiyor, yoksa biri "kullanılmıyor" diye
    siler.
  */
  if (typeof pencere.structuredClone !== "function") {
    eksikler.push("structuredClone");
  }

  /*
    `Intl` — bütün tarih ve sayı biçimlemesi Türkçe yerelle yapılıyor.
    Yoksa tarihler ham ISO dizgisi olarak görünür.
  */
  if (typeof pencere.Intl !== "object" || pencere.Intl === null) {
    eksikler.push("Intl");
  }

  return { destekli: eksikler.length === 0, eksikler };
}
